import { useQuery } from "@tanstack/react-query";
import { fetchHealthCheck } from "./endpoints";
export const useHealthCheck = (pollUrl) => {
    const { data: healthCheck, isLoading, isFetching, isError, error, refetch, } = useQuery({
        queryKey: ['healthCheck', pollUrl],
        queryFn: () => fetchHealthCheck(pollUrl),
        enabled: !!pollUrl,
    });
    return {
        healthCheck: healthCheck !== null && healthCheck !== void 0 ? healthCheck : {
            success: false,
            errorDescription: '',
            categories: [],
        },
        isLoading,
        isFetching,
        isError,
        error,
        refetch,
    };
};
